export const routes = {
  root: "/",
  home: "home",
  orders: "orders",
  orderDetails: "orders/:orderId",
  orderDetailsPreview: "data-triage/preview",
  orderDetailsReviewMappings: "data-triage/review-mappings",
  userManagement: "user-management",
  qualityFramework: "quality-framework",
  qualityFrameworkCreate: "quality-framework/create",
  qualityFrameworkAssignUsers: "quality-framework/create/assign-users",
  qualityFrameworkCheckList: "quality-framework/check-list",
  laap: "laap",
};
